import logo from '../mlogo.png';
import './App.css';
import {Alert, Button, Card, Col, Container, Nav, Navbar, Row, Spinner} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {gapi} from "gapi-script";
import {GoogleOAuthProvider} from "@react-oauth/google";
import AppContext from '../contexts/app-context'
import * as config from "../Config";
import Logout from "../components/logout";
import Login from "../components/login";
import * as backendUtils from "../helper/BackendUtils";
import {Slide, ToastContainer} from "react-toastify";
import {NavLink, Outlet} from "react-router-dom";

const clientId = process.env.REACT_APP_CLIENT_ID;
const competitionStartDate = '2023-05-01';//TODO read from proper event

function App() {

    useEffect(() => {
        function start() {
            gapi.client.init({
                clientId: clientId,
                scope: ""
            })
        }

        gapi.load('client:auth2', start);
    });
    const useMatchMedia = (mediaQuery, initialValue) => {
        const [isMatching, setIsMatching] = useState(initialValue)
        useEffect(() => {
            const watcher = window.matchMedia(mediaQuery)
            setIsMatching(watcher.matches)
            const listener = (matches) => {
                setIsMatching(matches.matches)
            }
            if (watcher.addEventListener) {
                watcher.addEventListener('change', listener)
            } else {
                watcher.addListener(listener)
            }
            return () => {
                if (watcher.removeEventListener) {
                    return watcher.removeEventListener('change', listener)
                } else {
                    return watcher.removeListener(listener)
                }
            }
        }, [mediaQuery])

        return isMatching
    }

    const isDesktopResolution = useMatchMedia('(min-width:992px)', true)

    const [user, setUser] = useState(null)
    const [backendUri, setBackendUri] = useState(null);
    const [showSpinner, setShowSpinner] = useState(true);
    const [messageOfTheDay, setMessageOfTheDay] = useState("");

    useEffect(() => {
        async function getBackend() {
            const data = config.getBackendUri();
            if (data) {
                setBackendUri(data.url);
            }
        }

        void getBackend();
    }, []);

    useEffect(() => {
        setShowSpinner(false)
    }, [user])

    useEffect(() => {
        const fetchMessage = () => {
            if (backendUri && user) {
                backendUtils.getRequest(`${backendUri}/event/message`, {},
                    response => {
                        setMessageOfTheDay(response.data);
                    }, err => {
                        console.log("Unable to read mesg of the day:" + backendUtils.getErrorMessage(err));
                    }
                ).catch((err) => console.log((err)))
            }
        }
        fetchMessage()
    }, [user, backendUri])

    return (
        <AppContext.Provider value={{backendUri: backendUri, userId: user?.email, startFrom: competitionStartDate}}>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"/>
            <GoogleOAuthProvider clientId={clientId}>
                <Container>
                    <Row>
                        <Col>
                            {messageOfTheDay !== "" && user ?
                                <Alert key="primary" variant="primary" dismissible>{messageOfTheDay}</Alert>
                                :
                                <div/>
                            }
                        </Col>
                    </Row>
                    <Row>
                        {
                            user ?
                                <Row>
                                    <Col className="col-lg-4 col-sm-12">
                                        <Navbar className="me-auto w-100" expand="lg">
                                            <Container className="container-fluid p-2">
                                                {
                                                    isDesktopResolution &&
                                                    <Navbar.Brand className="d-flex logo text-center m-0">
                                                        <img alt="logo" src={logo}/>
                                                    </Navbar.Brand>
                                                }
                                                <Row className="hi-row">
                                                    <Col className="col text-center p-2">
                                                        <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                                                        <img className="m-1"
                                                             style={{width: 40, height: 40}}
                                                             src={user.imageUrl}
                                                             alt=""/>
                                                    </Col>
                                                    <Col className="col p-3">
                                                        <span className="text-body">Hi, {user.givenName}</span>
                                                    </Col>
                                                </Row>
                                                <GoogleOAuthProvider clientId={clientId}>
                                                    <div className="m-1 navbar-nav">
                                                        <Logout handleLoggedOut={() => {
                                                            setUser(null)
                                                            localStorage.removeItem('token')
                                                        }}/>
                                                    </div>
                                                </GoogleOAuthProvider>
                                                <Navbar.Collapse id="basic-navbar-nav">
                                                    <hr/>
                                                    <Nav>
                                                        <NavLink to="/bike/home">
                                                            <Button className="navbar-btn">
                                                                Home
                                                            </Button>
                                                        </NavLink>
                                                        <NavLink to="/bike/events">
                                                            <Button className="navbar-btn">
                                                                Events
                                                            </Button>
                                                        </NavLink>
                                                        <NavLink to="/bike/join">
                                                            <Button className="navbar-btn">
                                                                Join Events
                                                            </Button>
                                                        </NavLink>
                                                        <NavLink to="/bike/feed">
                                                            <Button className="navbar-btn">
                                                                Today's Efforts
                                                            </Button>
                                                        </NavLink>
                                                        <NavLink to="/bike/stats">
                                                            <Button className="navbar-btn">
                                                                Statistics
                                                            </Button>
                                                        </NavLink>
                                                        <hr/>
                                                    </Nav>
                                                    <Nav.Link
                                                        href="https://batchat.motorolasolutions.com/home/ls/space/4859397606014976/bike-2-work-krakow-space/home">
                                                        Batchat Space
                                                    </Nav.Link>
                                                    <Nav.Link href="https://bike2work.rocks/">Connect with
                                                        Strava
                                                    </Nav.Link>
                                                </Navbar.Collapse>
                                            </Container>
                                        </Navbar>
                                    </Col>
                                    <Col className="col p-2">
                                        {
                                            user ?
                                                <Outlet/> :
                                                (
                                                    showSpinner ?
                                                        <Spinner animation="grow" variant="danger"/> :
                                                        <div/>
                                                )
                                        }
                                    </Col>
                                </Row>
                                :
                                <Card className="p-3 text-center">
                                    <div className="text-center">
                                        <img alt="logo" src={logo}/>
                                    </div>
                                    <Card.Body>
                                        <Card.Title>Bike2Work</Card.Title>
                                        <br></br>
                                        <Card.Text>
                                            Welcome to the Bike2Work competition application!
                                        </Card.Text>
                                        <br></br>
                                        <Card.Text>
                                            Here, you can join events, register your rides, see the progress and
                                            compare
                                            your
                                            results to other riders.
                                        </Card.Text>
                                        <br></br>
                                        <Card.Text>
                                            Don't forget to follow our BatChat Community so you won't miss out any
                                            important
                                            information
                                        </Card.Text>
                                        <br></br>
                                        <br></br>
                                        <Login
                                            handleLoggedIn={(user) => {
                                                setUser(user)
                                            }}
                                            handleFailure={(reason => console.log(reason))}
                                        />
                                    </Card.Body>
                                </Card>
                        }
                    </Row>
                </Container>
                <ToastContainer
                    transition={Slide}
                    position="bottom-center"
                    autoClose={3000}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss={false}
                    draggable={false}
                    pauseOnHover={false}
                />
            </GoogleOAuthProvider>
        </AppContext.Provider>
    )
}

export default App;
